module.exports = __webpack_public_path__ + "img/solicitud-en-linea.d230e090.svg";